import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const QuizFooter = ({
  state,
  dispatch,
  uniqueSections,
  setShow,
  isSectionMode,
}) => {
  // Find the current question
  const currentQuestion = state.questions[state.currentQuestionIndex];

  // Find the n_section of the current question
  const currentNSection = currentQuestion?.n_section;

  // Find the index of the current section in our unique array
  // This tells us if we are on section 0, 1, 2, etc.
  const currentSectionArrayIndex = uniqueSections.findIndex(
    (sectionId) => sectionId === (currentNSection ?? currentQuestion.id)
  );
  const handleNext = () => {
    if (currentSectionArrayIndex >= uniqueSections.length - 1) {
      console.log("Already at the last section");
      return;
    }

    // Find the next section's ID from our unique array
    const nextSectionId = uniqueSections[currentSectionArrayIndex + 1];

    // Find the index of the FIRST question that belongs to the next section
    const firstQuestionIndexOfNextSection = state.questions.findIndex(
      (q) => (q.n_section ?? q.id) === nextSectionId
    );

    if (firstQuestionIndexOfNextSection !== -1) {
      dispatch({
        type: "setCurrentQuestionIndex",
        payload: state.questions[firstQuestionIndexOfNextSection].id,
      });
    }
  };

  const handleBack = () => {
    if (currentSectionArrayIndex <= 0) {
      return;
    }

    // Find the previous section's ID from our unique array
    const prevSectionId = uniqueSections[currentSectionArrayIndex - 1];

    // Find the index of the FIRST question that belongs to the previous section
    const firstQuestionIndexOfPrevSection = state.questions.findIndex(
      (q) => (q.n_section ?? q.id) === prevSectionId
    );
    if (firstQuestionIndexOfPrevSection !== -1) {
      dispatch({
        type: "setCurrentQuestionIndex",
        payload: state.questions[firstQuestionIndexOfPrevSection].id,
      });
    }
  };

  return (
    <footer className="amd-hero:gap-[16px]  !px-6 bg-[#E5EBF5] h-[80px]   flex  w-full  items-center justify-between border-line-top py-5 ">
      <div className="md:hidden">
        <p className=" text-black">Nash Academy</p>
      </div>
      <div
        onClick={() => setShow(true)}
        className="numbering cursor-pointer flex w-fit justify-center gap-[4px] rounded-3xl bg-black hover:bg-white hover:text-black border border-black  p-[8px]  text-white md:w-[100px] duration-200"
      >
        <span className="font-bold md:hidden">
          {" "}
          {isSectionMode ? "Section" : "Question"}
        </span>
        <span className="current-question-number">
          {currentSectionArrayIndex + 1}
        </span>
        <span className="font-bold">of</span>
        <span className="questions-count"> {uniqueSections.length}</span>
      </div>

      <div className="control-buttons flex justify-center gap-[20px]">
        <button
          onClick={handleBack}
          disabled={currentSectionArrayIndex === 0}
          className=" flex px-5 py-3 justify-center rounded-3xl bg-blue-700  text-center  text-white duration-200  active:scale-90 "
        >
          <span className="md:hidden">Back</span>
          <FontAwesomeIcon
            className="hidden rotate-180 text-[20px] font-bold md:block"
            icon={faChevronRight}
          />{" "}
        </button>

        <button
          onClick={handleNext}
          disabled={currentSectionArrayIndex === uniqueSections.length - 1}
          className=" flex px-5 py-3 justify-center rounded-3xl bg-blue-700  text-center  text-white duration-200  active:scale-90 "
        >
          <span className="md:hidden">Next</span>

          <FontAwesomeIcon
            className="hidden text-[20px] font-bold md:block"
            icon={faChevronRight}
          />
        </button>
      </div>
    </footer>
  );
};

export default QuizFooter;
